/**
 * UUID v4 generator with secure-context fallback.
 *
 * `crypto.randomUUID()` is only available in secure contexts (HTTPS or
 * localhost). When the dev panel runs at `http://demo.saquei.local:47002`
 * (custom hostname over HTTP), it throws. This helper falls back to
 * `Math.random()` which is non-crypto-strong but acceptable for
 * Idempotency-Keys (uniqueness within a tenant suffices; collisions are
 * cosmetic since the server's composite PK protects integrity).
 */
export function randomUuid(): string {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        try {
            return crypto.randomUUID();
        } catch {
            // crypto.randomUUID throws in non-secure contexts; fall through.
        }
    }
    const hex = "0123456789abcdef";
    let s = "";
    for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            s += "-";
        } else if (i === 14) {
            s += "4"; // version
        } else if (i === 19) {
            s += hex.charAt(8 + Math.floor(Math.random() * 4)); // variant 10xx
        } else {
            s += hex.charAt(Math.floor(Math.random() * 16));
        }
    }
    return s;
}
